import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Mini-mapa de SOLO LECTURA para mostrar un punto único con Leaflet + OpenStreetMap (GRATIS, sin API key).
// Usa circleMarker para evitar problemas de assets de iconos por defecto de Leaflet.
export function GeoMiniMapa({ lat, lng, testid = "geo-mini-mapa", height = "h-40" }) {
  const ref = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    if (!ref.current || lat == null || lng == null) return;
    if (map.current) {
      map.current.setView([lat, lng], 16);
    } else {
      map.current = L.map(ref.current, {
        center: [lat, lng], zoom: 16, scrollWheelZoom: false, attributionControl: false,
      });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map.current);
    }
    const layer = L.layerGroup().addTo(map.current);
    L.circleMarker([lat, lng], { radius: 9, color: "#0f766e", fillColor: "#14b8a6", fillOpacity: 0.9 }).addTo(layer);
    return () => { layer.remove(); };
  }, [lat, lng]);

  useEffect(() => () => { map.current?.remove(); map.current = null; }, []);

  return <div ref={ref} data-testid={testid} className={`${height} w-full overflow-hidden rounded-md border border-slate-200`} />;
}
